import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import FaceIcon from '@material-ui/icons/Face';
import DoneIcon from '@material-ui/icons/Done';
import LoadingIndicator from '../../components/LoadingIndicator';
import apiManager from '../../../src/ApiManager';

// NOTE: STRIPE PROCESSING IN NO LONGER HANDLED HERE....IT'S VIA THE "CHECKOUT" BUTTON IN THE HOMEUSER.JS FILE
import {
  STAGE,
  STRIPE_BASE_URL,
  STRIPE_BASIC_PRODUCT_ID,
  STRIPE_PUBLIC_KEY,
} from '../../constants';

const BASE_URL = STRIPE_BASE_URL;
// const IS_LOCAL = window.location.hostname === 'localhost';
// const BASE_URL = IS_LOCAL ? 'http://localhost:3000' : 'https://soilhealthacademy.narrasys.com'; // TODO: STAGE/PROD URLS
// const API_BASE_URL = IS_LOCAL ? 'http://localhost:8050' : ''; // TODO: STAGE/PROD URLS

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '& > *': {},
  },
}));

// const products = {
//   stage: {
//     basicProductPlan: 'price_1He0BEKWzGJSIihVxm1EB9Xb',
//   },
//   prod: {
//     basicProductPlan: 'price_1HXZAAKWzGJSIihVDJRG2PMi', // Prod $1: price_1HXZAQKWzGJSIihVldyfPoXR / price => for $499 use: price_1HXZAAKWzGJSIihVDJRG2PMi
//   },
// };

export default function SubscribeButton(props) {
  const { course, handleClassClick, index, showDiscount, isRenewal } = props;
  console.log(course);
  const classes = useStyles();

  const [isLoading, setLoading] = React.useState(false);
  const [isSelected, setSelected] = React.useState(false);
  const handleClick = () => {
    // if(!isSelected){
    //   handleClassClick(course, false)
    // } else {
    //   handleClassClick(course, true)
    // }
    // setSelected(!isSelected)
    handleClassClick(course, false);
  };

  debugger;
  // const stripe = window.Stripe(STRIPE_PUBLIC_KEY);
  // const stripe = course.stripeConfig[STAGE].publicKey;
  const productId = course.stripeConfig.basicProductPlan;

  const stripeStandardCheckout = async () => {
    // Start Spinner
    setLoading(true);

    const attributes = await apiManager.currentAttributes();
    const { accessToken } = await apiManager.currentSession();
    const successUrl = `${BASE_URL}/subscription/success/{CHECKOUT_SESSION_ID}/`;
    const webUrl = `${BASE_URL}`;
    // alert(JSON.stringify(attributes));
    // alert(`${successUrl}?id={CHECKOUT_SESSION_ID}&user=` + encodeURIComponent(accessToken.jwtToken));

    // Call create-checkout-session for more custom experience
    // returns session to be used in redirectToCheckout
    // const session = await apiManager.createCheckoutSession({
    //   lineItems: [{ price: productId, quantity: 1 }],
    //   customerEmail: attributes['email'],
    //   customerPhone: (attributes && attributes['custom:phone']) ? attributes['custom:phone'] : '',
    //   customerReferralURL: localStorage.getItem('referrerURL'),
    //   token: accessToken.jwtToken,
    //   successUrl: `${successUrl}?id={CHECKOUT_SESSION_ID}&user=` + encodeURIComponent(accessToken.jwtToken),
    //   cancelUrl: webUrl + '/subscription/error', // /#error
    // });

    // payment_method_types: ['card'],
    //     line_items: [{ price: productId, quantity: 1 }],
    //     mode: 'payment',
    //     customer_email: customerEmail,
    //     client_reference_id: decoded.sub,
    //     allow_promotion_codes: true,
    //     success_url: successUrl,
    //     cancel_url: cancelUrl,

    // if(session && session.id) {
    //   stripe.redirectToCheckout({ sessionId: session.id });
    // } else {
    //   setLoading(false);
    //   alert('There was a problem with initializing the checkout page. Please contact support at: support@regenagonline.com');
    // }
  };

  const styling =
    props.size && props.size === 'small'
      ? { fontSize: 12 }
      : { paddingTop: 8, paddingBottom: 8, fontSize: 20 };

  return (
    <div>
      {isLoading ? (
        <LoadingIndicator />
      ) : (
        <>
          <Button
            type="submit"
            // style={styling}
            id={`checkout-button-${productId}`}
            // onClick={stripeStandardCheckout}
            onClick={handleClick}
            color="primary"
            size="small"
            fullWidth
            // variant={isSelected ? "outlined" : "contained"}
            variant="contained"
            style={{ width: 200 }}
          >
            {isSelected ? 'Selected' : 'Subscribe to'}
            <br />
            {course.name}
          </Button>
          <div style={{ textAlign: 'center', margin: 12 }}>
            <p>
              {course.price}
              <br />
              {showDiscount && (
                <>
                  <b>
                    {' '}
                    $
                    {course.stripeConfig[course.stripeConfig.basicProductPlan] -
                      course.stripeConfig[
                        course.stripeConfig.basicProductPlanBundle
                      ]}
                    /year
                  </b>{' '}
                  with multi-course discount
                </>
              )}
            </p>
            {/* <p style={{marginTop: '1.5rem'}}>Bundle and save!</p> */}
          </div>
        </>
      )}
    </div>
  );
}
